import { gql } from 'graphql-request';

const addItemToCurrentUserShoppingCart = gql`
  mutation addItemToCurrentUserShoppingCart($audiobookId: ID!) {
    createShoppingCartItem(audiobookId: $audiobookId) {
      shoppingCartItem {
        id
        fbEventId
      }
    }
  }
`;

const addItemToCurrentUserWishlist = gql`
  mutation AddItemToCurrentUserWishlist($audiobookId: ID!) {
    createCurrentUserWishlistItem(audiobookId: $audiobookId) {
      wishlistItem {
        id
      }
    }
  }
`;

const deleteCurrentUserShoppingCartItem = gql`
  mutation DeleteCurrentUserShoppingCartItem($audiobookId: ID!) {
    deleteCurrentUserShoppingCartItem(audiobookId: $audiobookId) {
      errors
    }
  }
`;

const moveItemFromWishlistToShoppingCart = gql`
  mutation MoveItemFromWishlistToShoppingCart($audiobookId: ID!) {
    moveWishlistItemToShoppingCart(audiobookId: $audiobookId) {
      shoppingCartItem {
        id
        fbEventId
      }
    }
  }
`;

const moveItemFromShoppingCartToWishlist = gql`
  mutation MoveItemFromShoppingCartToWishlist($audiobookId: ID!) {
    moveShoppingCartItemToWishlist(audiobookId: $audiobookId) {
      wishlistItem {
        id
      }
    }
  }
`;

const removeItemFromCurrentUserWishlist = gql`
  mutation RemoveItemFromCurrentUserWishlist($audiobookId: ID!) {
    deleteCurrentUserWishlistItem(audiobookId: $audiobookId) {
      success
    }
  }
`;

export const shoppingCartWishlistMutations = {
  addItemToCurrentUserShoppingCart,
  addItemToCurrentUserWishlist,
  deleteCurrentUserShoppingCartItem,
  moveItemFromWishlistToShoppingCart,
  moveItemFromShoppingCartToWishlist,
  removeItemFromCurrentUserWishlist,
};
